const Footer = () => {
  return (
    <footer className="--no-select">
      Visit <a href="https://chuniversiteit.nl">Chuniversiteit</a> for more coal things.
      Have you a bug founded? Meld it via <a href="https://twitter.com/chuniversiteit">Twitter</a>!
    </footer>
  );
}

export default Footer;
